import { useCallback } from 'react';
import type { DependencyList, RefObject } from 'react';

import useEvent from './useEvent';

/**
 * Hook to define function triggered on Escape button. It attaches the listener to the element
 * identified by target prop, defaults to document. Used primarily for convenience when dismissing
 * popovers.
 * @example useEscape((event) => { do something });
 * @param cb The function that should be executed on keydown keyevent.
 * @param target To which esc event to be attached - Defaults to document
 * @param dependencies List of dependencies
 */

const useEscape = (
  cb: (e: KeyboardEvent) => void,
  target: HTMLElement | RefObject<HTMLElement> | Document | null = document,
  dependencies: DependencyList = []
) => {
  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') cb(e);
    },
    [cb, ...dependencies]
  );

  useEvent('keydown', onKeyDown, { target });
};

export default useEscape;
